import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '../store/hooks';
import { logout } from '../store/slices/authSlice';
import { isJwtExpired } from '../auth/jwt/tokenUtils';

interface PrivateRouteProps {
    children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
    const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
    const user = useAppSelector((state) => state.auth.user);
    const token = useAppSelector((state) => state.auth.token);
    const dispatch = useAppDispatch();
    const isTokenValid = !!token && !isJwtExpired(token);

    useEffect(() => {
        // Enforce role and token validity on route open.
        if (isAuthenticated && (!isTokenValid || user?.role !== 'admin')) {
            console.warn('Access denied. Admin privileges required.');
            dispatch(logout());
        }
    }, [isAuthenticated, isTokenValid, user, dispatch]);

    if (!isAuthenticated || !isTokenValid) {
        return <Navigate to="/login" replace />;
    }

    // Double-check admin role
    if (user?.role !== 'admin') {
        return <Navigate to="/login?error=insufficient_privileges" replace />;
    }

    return <>{children}</>;
};

export default PrivateRoute;
